import { topRated } from '@/mocks/homeData';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TopRated() {
  return (
    <section id="toprated" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="口碑靠前"
          title="高分佳作：经得起细看的那几部"
          desc="分数不是唯一标准，但能帮你先缩小范围。以下作品在长短评里都收获了稳定好评。"
          actionLabel="加入我的片单"
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topRated.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-xl border border-background-200 bg-background-100/60 p-5 transition hover:border-accent-300"
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500">
                    {item.year} · {item.genre}
                  </p>
                </div>
                <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-2.5 py-1 text-sm font-semibold text-background-50">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                  {item.score}
                </span>
              </div>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">{item.oneLiner}</p>
              <a href="#subscribe" className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-700 cursor-pointer">
                收藏到片单
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-add-line text-base"></i>
                </span>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}